module.exports = __webpack_public_path__ + "static/media/no-offers.b7a59313.svg";